import { render, staticRenderFns } from "./MonitoredSymptomList.vue?vue&type=template&id=11b40197&"
import script from "./MonitoredSymptomList.vue?vue&type=script&lang=js&"
export * from "./MonitoredSymptomList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VList})
